import React, { useState, useEffect } from "react";
import axios from "axios";
import Pending from "../../../assets/Icon/pending.png";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import AllModuleData from "../../../Components/Reuseable/AllModuleData";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const PendingPost = () => {
  const [event_data, setEvents] = useState([]);
  const [count, setCount] = useState([]);
  const [buffer, setBuffer] = useState(true);

  // Fetch Approved LiveChat
  useEffect(() => {
    axios.get(`/api/star/learning_session/pending`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setEvents(res.data.events);
        setCount(res.data.count);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title="Pending Learning Session"
        image={Pending}
        count={count}
      />
      {buffer ? (
        <LoaderPost />
      ) : (
        <AllModuleData
          data={event_data}
          urlLink={`/superstar/learning-session/details`}
        />
      )}
    </>
  );
};

export default PendingPost;
